import cn from 'clsx';

import css from './SubscriptionMessage.module.css';

const SubscriptionMessage = ({ children }: { children: React.ReactNode }) => {
  return <p className={cn('glz-p glz-is-size-3', css.text)}>{children}</p>;
};

export { SubscriptionMessage };
